import React, { useState } from 'react'
import { CircularProgress, Typography } from '@material-ui/core'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline'

function PlusMinusButton(props) {
  const { onChange, loading, max } = props
  const [value, setValue] = useState(0)

  const onPlus = () => {
    if (max !== 'undefined' && value >= max) {
      return
    }
    setValue(value + 1)
    if (onChange) {
      onChange(value + 1)
    }
  }

  const onMinus = () => {
    if (value > 0) {
      setValue(value - 1)
      if (onChange) {
        onChange(value - 1)
      }
    }
  }

  if (loading) return <CircularProgress size={10} />
    return (
      <>
        <AddCircleOutlineIcon fontSize='medium' onClick={onPlus} />
        <Typography component={'span'} variant='body1' style={{ margin: 10 }}>
          {value}
        </Typography>
        <RemoveCircleOutlineIcon fontSize='medium' onClick={onMinus} />
      </>
    )
}

export default PlusMinusButton
